import CryptoJS from 'crypto-js';

// const KEY = 'in-email-pwd-enc';
// const IV = 'in-email-pwd-enc'; // 添加偏移量
const KEY = 'inemailpwdenc';
const IV = 'adf322271bbf4d94';

function fillKey(key: string, keySize: number) {
  keySize = keySize || 128;
  let filledKey = Buffer.alloc(keySize / 8);
  let keys = Buffer.from(key);
  if (keys.length < filledKey.length) {
    for (let i = 0; i < filledKey.length; i++) {
      filledKey[i] = keys[i];
    }
  }
  return filledKey;
}
 
// 加密
export const encrypt = (message: any) => {
  if(message === '' || message === null || message === undefined){
    return '';
  }
  let keyAccept = CryptoJS.lib.WordArray.create(fillKey(KEY, 128));
  let giv = CryptoJS.enc.Utf8.parse(IV);
  let messageJson = '';
  if (typeof message === 'object') {
    messageJson = JSON.stringify(message);
  } else {
    messageJson = message;
  }
 
  return base64ToHex(CryptoJS.AES.encrypt(messageJson, keyAccept, {
    iv: giv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString());
};
 
// 解密
export const decrypt2 = (encryptedBase64Str: string) => {
  if(encryptedBase64Str === '' || encryptedBase64Str === null || encryptedBase64Str === undefined){
    return '';
  }
  let resBase64 = hexToBase64(encryptedBase64Str)
  let keyResponse = CryptoJS.lib.WordArray.create(fillKey(KEY, 128));
  let giv = CryptoJS.enc.Utf8.parse(IV);
  let decrypt1 = CryptoJS.AES.decrypt(resBase64, keyResponse, {
    iv: giv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  const message = decrypt1.toString(CryptoJS.enc.Utf8);
  return message; // JSON.parse(message);
};
export const hexToBase64 = data => {
  let d = CryptoJS.enc.Hex.parse(data);
  return CryptoJS.enc.Base64.stringify(d);
};
export const base64ToHex = data => {
  let d = CryptoJS.enc.Base64.parse(data);
  return CryptoJS.enc.Hex.stringify(d);
};


// WEBPACK FOOTER //
// ./src/utils/crypto.ts